var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "20 60 220 140",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .statusFill {\n            fill: #2A6FAE;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer3",
    transform: "matrix(10,0,0,10,-70,-70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.57527,0,0,1.57527,5.08013,14.9043)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.028,
    cy: 5.139,
    r: 2.539,
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.57527,0,0,1.57527,19.0801,14.9043)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.028,
    cy: 5.139,
    r: 2.539,
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.736065,1.02149e-16,-8.01262e-17,-0.741429,35.277,25.3223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.396,14.597L16.3,14.597C16.008,14.596 15.748,14.411 15.655,14.135C15.655,14.135 11.889,2.919 11.889,2.919C11.771,2.566 11.386,2.375 11.03,2.492C10.675,2.61 10.482,2.992 10.601,3.345C10.601,3.345 13.416,11.729 14.367,14.562C14.644,15.388 15.423,15.945 16.3,15.945L19.396,15.945C19.771,15.945 20.076,15.643 20.076,15.271C20.076,14.899 19.771,14.597 19.396,14.597Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.54471,0,0,2.02631,-13.5161,-18.6763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.033,20.568C16.033,20.976 16.468,21.308 17.004,21.308L21.856,21.308C22.29,21.308 22.671,21.089 22.79,20.771C23.121,19.887 23.951,17.674 23.951,17.674C24,17.543 23.9,17.407 23.728,17.369C23.557,17.332 23.377,17.408 23.328,17.539C23.328,17.539 22.499,19.752 22.168,20.635C22.128,20.741 22.001,20.814 21.856,20.814C21.856,20.814 17.004,20.814 17.004,20.814C16.825,20.814 16.68,20.704 16.68,20.568C16.68,20.568 16.68,20.568 16.68,20.567C16.68,20.502 16.714,20.439 16.775,20.393C16.836,20.347 16.918,20.321 17.004,20.321L20.741,20.321C21.063,20.321 21.365,20.199 21.545,19.996C21.726,19.792 21.762,19.534 21.643,19.306C21.389,18.822 21.06,18.195 20.866,17.825C20.718,17.544 20.361,17.36 19.964,17.36L16.518,17.36C16.261,17.36 16.014,17.438 15.832,17.577C15.65,17.715 15.547,17.904 15.547,18.1L15.547,18.1C15.547,18.296 15.65,18.485 15.832,18.623C16.014,18.762 16.261,18.84 16.518,18.84C17.463,18.84 19.108,18.84 19.108,18.84C19.286,18.84 19.431,18.73 19.431,18.594C19.431,18.457 19.286,18.347 19.108,18.347L16.518,18.347C16.432,18.347 16.35,18.321 16.289,18.275C16.229,18.228 16.195,18.165 16.195,18.1C16.195,18.1 16.195,18.1 16.195,18.1C16.195,18.035 16.229,17.972 16.289,17.926C16.35,17.879 16.432,17.853 16.518,17.853L19.964,17.853C20.097,17.853 20.216,17.915 20.265,18.008L21.042,19.489C21.082,19.565 21.069,19.651 21.009,19.719C20.949,19.787 20.848,19.827 20.741,19.827C20.741,19.827 17.004,19.827 17.004,19.827C16.746,19.827 16.499,19.905 16.317,20.044C16.135,20.183 16.033,20.371 16.033,20.568ZM16.033,20.568C16.033,20.568 16.033,20.568 16.033,20.568L16.033,20.568Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,21,3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,22L11.998,22C10.895,22 10,22.895 10,23.998L10,24.002C10,25.105 10.895,26 11.998,26C12.999,26 14,26 14,26L14,22Z",
    className: "statusFill"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooter);
export default __webpack_public_path__ + "static/media/scooter.4dc1b4c88d82b0ba39bc5694f7a71449.svg";
export { ForwardRef as ReactComponent };